"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// (C) 2007-2020 GoodData Corporation
exports.DEFAULT_DECIMAL_FORMAT = "#,##0.00";
exports.DEFAULT_PERCENTAGE_FORMAT = "#,##0.00%";
exports.DEFAULT_INTEGER_FORMAT = "#,##0";
